import DataTable from "datatables.net";
import {Order} from "datatables.net-bs5";
import { openRunsModal } from './home/runs-modal';

export default class {
    static init = () => {
        runs();
        ranges();
        streaks();
        stairmaster();
        stairmasterRanges();
        stairmasterStreaks();
    }
}

function runs() {
    const dt = new DataTable('.datatable[data-table="runs"]',{
        pageLength: 25,
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getRuns',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: 'index', orderable: false },
            { data: 'date' },
            { data: 'steps' },
            { data: 'time' },
            { data: 'miles' },
            { data: 'km' },
            { data: 'steps_hr' },
            { data: 'miles_hr' },
            { data: 'km_hr' },
            { data: 'miles_pace' },
            { data: 'km_pace' },
            { data: 'kcal' },
            { data: 'source', orderable: false, render: function(source: string) {
                return source === 'oura' ? '<span class="badge bg-info bg-opacity-10 text-info">Oura</span>' : '';
            } },
            { data: 'runs_id', visible: false },
            { data: 'date_raw', visible: false }
        ],
        order: [[1,"desc"]] as Order[],
        drawCallback: function(_settings: any) {
            const api = dt;
            const rows = api.rows({ page: 'current' }).nodes();
            let lastDate: string | null = null;
            let spanCell: HTMLTableCellElement | null = null;
            let spanCount = 0;

            api.column(1, { page: 'current' }).nodes().each(function(cell: any, i: number) {
                const rowData = api.row(rows[i]).data() as any;
                const td = cell as HTMLTableCellElement;

                if (rowData.date === lastDate && spanCell) {
                    spanCount++;
                    spanCell.rowSpan = spanCount;
                    td.style.display = 'none';
                } else {
                    lastDate = rowData.date;
                    spanCell = td;
                    spanCount = 1;
                    td.style.display = '';
                    td.rowSpan = 1;
                }
            });
        },
        createdRow: function(row: Node, data: any) {
            const el = row as HTMLElement;
            el.style.cursor = 'pointer';
            el.addEventListener('click', () => {
                openRunsModal(data.date_raw);
            });
        }
    });
}

function ranges() {
    new DataTable('.datatable[data-table="ranges"]',{
        pageLength: 25,
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getRanges',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: 'range' },
            { data: 'num' },
            { data: 'steps' },
            { data: 'time' },
            { data: 'miles' },
            { data: 'km' },
            { data: 'steps_hr' },
            { data: 'miles_hr' },
            { data: 'km_hr' },
            { data: 'miles_pace' },
            { data: 'km_pace' },
            { data: 'kcal' }
        ],
        order: [[0,"asc"]] as Order[]
    });
}

function streaks() {
    new DataTable('.datatable[data-table="streaks"]',{
        pageLength: 25,
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getStreaks',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: 'dates' },
            { data: 'row_count' },
            { data: 'steps' },
            { data: 'time' },
            { data: 'miles' },
            { data: 'km' },
            { data: 'steps_hr' },
            { data: 'miles_hr' },
            { data: 'km_hr' },
            { data: 'miles_pace' },
            { data: 'km_pace' },
            { data: 'kcal' },
            { data: 'weight' },
            { data: 'waist' },
            { data: 'alc' }
        ],
        order: [[1,"desc"]] as Order[],
        createdRow: function(row, data : { [key: string]: any }, dataIndex, cells) {
            let element = row as HTMLElement;
            if(data.is_current) {
                element.classList.add('row-current');
            }
        }
    });
}

function stairmaster() {
    const el = document.querySelector('.datatable[data-table="stairmaster"]');
    if (!el) return;
    new DataTable('.datatable[data-table="stairmaster"]', {
        pageLength: 25,
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getStairmaster',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: 'index', orderable: false },
            { data: 'date' },
            { data: 'steps' },
            { data: 'time' },
            { data: 'floors' },
            { data: 'miles' },
            { data: 'km' },
            { data: 'stairmaster_id', visible: false },
            { data: 'date_raw', visible: false }
        ],
        order: [[1, 'desc']] as Order[]
    });
}

function stairmasterRanges() {
    const el = document.querySelector('.datatable[data-table="stairmaster_ranges"]');
    if (!el) return;
    new DataTable('.datatable[data-table="stairmaster_ranges"]', {
        pageLength: 25,
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getStairmasterRanges',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: 'range' },
            { data: 'num' },
            { data: 'steps' },
            { data: 'time' },
            { data: 'floors' },
            { data: 'km' }
        ],
        order: [[0, 'asc']] as Order[]
    });
}

function stairmasterStreaks() {
    const el = document.querySelector('.datatable[data-table="stairmaster_streaks"]');
    if (!el) return;
    new DataTable('.datatable[data-table="stairmaster_streaks"]', {
        pageLength: 25,
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getStairmasterStreaks',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: 'dates' },
            { data: 'row_count' },
            { data: 'steps' },
            { data: 'time' },
            { data: 'floors' },
            { data: 'km' }
        ],
        order: [[1, 'desc']] as Order[],
        createdRow: function(row, data : { [key: string]: any }, dataIndex, cells) {
            let element = row as HTMLElement;
            if(data.is_current) {
                element.classList.add('row-current');
            }
        }
    });
}
